export default String.raw`
<div class="customer-submenu">
    <div class="customer-submenu__header">
        {{translations.SOR}}
    </div>
    {% if customer.CompanyErpId <= 0 -%}
    <div class="no-data">{{ translations.AccessDenied }}</div>
    {% else %}
    <div class="eshop__table-container products erp-data-js" style="display: none" data-template="partials/customer-profile/sor/sor-details.html">
        <table>
            <colgroup>
                <col style="width:120px">
                <col style="width:140px">
                <col style="width:150px">
                <col style="width:150px">
                <col style="width:150px">
            </colgroup>
            <div class="erp-orders-tab">
                <label for="dateTo">{{ translations.SORFromLast3MonthsTo }}:</label>
                <input class="form__input-value get-erp-data-js" type="date" name="dateTo" id="dateTo">
            </div>
            <thead>
                <tr>
                    <th class="id">{{ translations.Number | Capitalize }}</th>
                    <th>{{ translations.BuyDate }}</th>
                    <th>{{ translations.ReleaseDate }}</th>
                    <th>{{ translations.Stock }}</th>
                    <th>{{ translations.Value }} {{ translations.Netto | Downcase }}</th>
                    <th>{{ translations.Value }} {{ translations.Brutto | Downcase }}</th>
                </tr>
            </thead>
            <div class="table-js" data-sp="CDN.eshop_GetSORs">
                <tbody>
                    <tr tabindex="0" class="row can-hover load-erp-sor-details-js parent-container-reload-js" data-url="{{ page.Url }}?&deeper-lvl=true&erp-data=true&sor-erp=true" rv-each-o="List">
                        <td class="id" rv-data-id="o.Id">{ o.ERPSORNumber }</td>
                        <td>{ o.Date | date }</td>
                        <td>{ o.ReleaseDate | date }</td>
                        <td>{ o.Warehouse }</td>
                        <td class="netto">{ o.SubtotalValue | price } { o.Currency }</td>
                        <td class="brutto">{ o.TotalValue | price } { o.Currency }</td>
                    </tr>
                </tbody>
            </div>
        </table>
        <div class="no-data">{{ translations.NoSOR }}</div>
        {% include 'partials/customer-profile/pagination.html' -%}
    </div>
    <div class="loader-js loader big"></div>
    {% endif -%}
</div>
`